import type { AuthUser } from '@/shared/stores/auth';

/**
 * בדיקת הרשאות-מסך בצד הלקוח (RBAC דינמי). זו שכבת UX בלבד — האכיפה
 * האמיתית בשרת (EnforceScreenPermission). משתמש בלי permissions (סשן ישן,
 * סופר-אדמין, בעלים או mock של e2e) מקבל הכל.
 */
export function canView(user: AuthUser | null, screen: string): boolean {
  return can(user, screen, 'view');
}

export function can(user: AuthUser | null, screen: string, action: 'view' | 'edit'): boolean {
  if (!user) return false;
  if (user.is_super_admin || user.role === 'owner') return true;
  if (!Array.isArray(user.permissions)) return true; // fallback — אין מידע, לא נועלים
  return user.permissions.includes(`${screen}.${action}`);
}
